// import { Component } from "react";
// import { RiChatSmile2Line } from "react-icons/ri";
// import { FaAngleDown } from "react-icons/fa6";
// import Logo from "../asset/images/red_tesla.jpeg";
// import { GoPaperAirplane } from "react-icons/go";
// import { connect } from "react-redux";
// import io from "socket.io-client";
// import { setUser } from "../reducer/userActions"; // new action to update user

// class ChatBox extends Component {
//   state = {
//     active: false,
//     message: "",
//     loading: false,
//   };

//   componentDidMount() {
//     const { user, setUser } = this.props;

//     // Initialize socket connection
//     this.socket = io("http://localhost:3001", {
//       auth: {
//         token: localStorage.getItem("teslaUserAccessToken"),
//       },
//     });

//     // Listen for chat updates from backend
//     this.socket.on("chatUpdated", (updatedChat) => {
//       // Update Redux user chat data
//       setUser({ ...user, chat: updatedChat });
//     });

//     // Cleanup on unmount
//     window.addEventListener("beforeunload", () => {
//       this.socket.disconnect();
//     });
//   }

//   componentWillUnmount() {
//     this.socket.disconnect();
//   }

//   handleChange = () => {
//     this.setState((prev) => ({ active: !prev.active }));
//   };

//   handleInput = (event) => {
//     const { name, value } = event.target;
//     this.setState({ [name]: value });
//   };

//   handleSubmit = (e) => {
//     e.preventDefault();
//     const { message } = this.state;
//     const { user } = this.props;

//     if (!message.trim()) return;

//     this.setState({ loading: true });

//     // Emit new message to server
//     this.socket.emit("sendMessage", {
//       userId: user.id, // assuming user has an id field
//       message,
//     });

//     // Clear input and loading state immediately or after confirmation
//     this.setState({ message: "", loading: false });
//   };

//   render() {
//     const { active, message } = this.state;
//     const { user } = this.props;
//     const chatbox = user?.chat || [];

//     const chatlist =
//       chatbox.length > 0
//         ? chatbox.map((list) => (
//             <li
//               className={list.person === "user" ? "right" : ""}
//               key={list.time}
//             >
//               {list.message}
//             </li>
//           ))
//         : null;

//     return (
//       <div className="chatbox_container">
//         <section className="icon_container" onClick={this.handleChange}>
//           <div className="icon_message">
//             <p>Chat Agent</p>
//           </div>
//           <RiChatSmile2Line />
//         </section>
//         <section className={`chat_environment_container ${active ? "" : "hide"}`}>
//           <div className="environment_contain">
//             <section className="client_chat_contain">
//               <div className="chat_head">
//                 <div className="chat_profile">
//                   <section className="image">
//                     <img src={Logo} alt="login" />
//                   </section>
//                   <section className="info">
//                     <h4>
//                       How can we help?
//                       <br />
//                       <span>We reply immediately</span>
//                     </h4>
//                   </section>
//                 </div>
//                 <button className="angle_drop" onClick={this.handleChange}>
//                   <FaAngleDown />
//                 </button>
//               </div>
//               <div className="chat_body">
//                 <li>Welcome! How can I assist you 🙂 </li>
//                 {chatlist}
//               </div>
//               <form className="chat_form" onSubmit={this.handleSubmit}>
//                 <textarea
//                   type="text"
//                   name="message"
//                   id="message"
//                   value={message}
//                   onChange={this.handleInput}
//                   required
//                 />
//                 <button type="submit" disabled={this.state.loading}>
//                   <GoPaperAirplane />
//                 </button>
//               </form>
//             </section>
//           </div>
//         </section>
//       </div>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   user: state.user,
// });

// const mapDispatchToProps = (dispatch) => ({
//   setUser: (user) => dispatch({ type: "SET_USER", payload: user }),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(ChatBox);





import { Component } from "react";
import { RiChatSmile2Line } from "react-icons/ri";
import { FaAngleDown } from "react-icons/fa6";
import Logo from "../asset/images/red_tesla.jpeg";
import { GoPaperAirplane } from "react-icons/go";
import { connect } from "react-redux";
import axios from "axios";
import { fetchUser } from "../reducer/userActions";

class ChatBox extends Component {
    chatInterval = null;
    chatEndRef = null;

    state = {
        active: false,
        message: "",
        chatbox: [],
        loading: false,
        error: ""
    };

    componentDidMount() {
        const { user } = this.props;
        if (user) {
            this.setState({ chatbox: user.chat });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const prevChat = prevProps.user?.chat;
        const currentChat = this.props.user?.chat;

        if (prevChat !== currentChat) {
            this.setState({ chatbox: currentChat || [] }, () => {
                this.scrollToBottom();
            });
        }
    }

    componentWillUnmount() {
        if (this.chatInterval) {
            clearInterval(this.chatInterval);
        }
    }

    handleChange = () => {
        this.setState(prev => {
            const newActiveState = !prev.active;

            if (newActiveState) {
                // Start polling every 5 seconds
                this.chatInterval = setInterval(() => {
                    this.props.fetchUser();
                }, 5000);
            } else {
                // Stop polling
                clearInterval(this.chatInterval);
                this.chatInterval = null;
            }

            return { active: newActiveState };
        });
    };

    handleInput = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken");
        const dataToSend = { message: this.state.message };

        try {
            const response = await axios.patch("https://teslasafebroker.com/api/user/chatbox", dataToSend, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.chat) {
                this.setState({ loading: false, message: "" });
                this.props.fetchUser();
                this.scrollToBottom();
            } else {
                this.setState({ loading: false });
            }
        } catch (error) {
            this.setState({ loading: false });

            if (error.response?.status === 401) {
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");

                const errorMessage = error.response.data?.message || error.response.statusText || "Authentication error. Redirecting to login...";
                this.setState({ error: errorMessage });

                setTimeout(() => {
                    window.location.href = "/login";
                }, 5000);
            } else {
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "An unexpected error occurred.";

                this.setState({ error: errorMessage });

                setTimeout(() => {
                    this.setState({ error: "" });
                }, 10000);
            }
        }
    };

    scrollToBottom = () => {
        if (this.chatEndRef) {
            this.chatEndRef.scrollIntoView({ behavior: "smooth" });
        }
    };

    render() {
        const { active, message, loading, chatbox, error } = this.state;

        const chatlist = chatbox.length > 0 ? chatbox.map(list => (
            <li className={list.person === "user" ? "right" : ""} key={list.time}>
                {list.message}
            </li>
        )) : null;

        return (
            <div className="chatbox_container">
                <section className="icon_container" onClick={this.handleChange}>
                    <div className="icon_message"><p>Chat Agent</p></div>
                    <RiChatSmile2Line />
                </section>

                <section className={`chat_environment_container ${active ? "" : "hide"}`}>
                    <div className="environment_contain">
                        <section className="client_chat_contain">
                            <div className="chat_head">
                                <div className="chat_profile">
                                    <section className="image">
                                        <img src={Logo} alt="login" />
                                    </section>
                                    <section className="info">
                                        <h4>
                                            How can we help?
                                            <br />
                                            <span>We reply immediately</span>
                                        </h4>
                                    </section>
                                </div>
                                <button className="angle_drop" onClick={this.handleChange}>
                                    <FaAngleDown />
                                </button>
                            </div>

                            <div className="chat_body">
                                <div>
                                    <li>Welcome! How can I assist you 🙂</li>
                                    {chatlist}
                                    <div ref={el => (this.chatEndRef = el)} />
                                </div>
                            </div>

                            <form className="chat_form" onSubmit={this.handleSubmit}>
                                <textarea
                                    type="text"
                                    name="message"
                                    id="message"
                                    value={message}
                                    onChange={this.handleInput}
                                    required
                                />
                                <button type="submit" disabled={loading}>
                                    <GoPaperAirplane />
                                </button>
                            </form>

                            {error && <div className="chat_error">{error}</div>}
                        </section>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps, { fetchUser })(ChatBox);
